import React, { Component } from 'react';
import {
  withRouter
} from 'react-router-dom';
import {
  Page,
  Card,
  Text,
  ProgressBar,
  BlockStack,
  Spinner,
  Tabs,
  Pagination,
  Tooltip,

} from '@shopify/polaris';
import {

} from '@shopify/polaris-icons';
import utils from '../../../../../utils/utils';

import {
  reqGetProductImagesData,
  reqBatchRestore,
  reqBatchReOptimize,
  reqUpdateIsDownload,
  reqGetOptSchedule,

} from "../../../../../api";
import Language from '../../../../../i18n/Language';
import IndexTableImage from '../components/IndexTableImage';
import ImageCompareModal from '../components/ImageCompare';
import FooterPageSelect from '../../../../../components/FooterPageSelect';
import { store } from '../../../../../redux/store';
import { cloneDeep } from 'lodash';
import '../index.css';
import FooterTrustHelp from '../../../../../components/FooterTrustHelp';

const t = Language;
let timerArr = [];

class ImageOptDetail extends Component {
  state = {
    showToast: false,
    showToastText: '',
    showToastIserror: false,
    queryValue: '',                                     // 搜索内容
    tableItemState: [],                                 // 表格批量对象

    tabKey: 0,
    Headings: [
      { title: '' },
      { title: t("Status") },
      { title: t("File type") },
      { title: t("Original Size") },
      { title: t("Reduction ratio") },
      { title: t("Compressed Size") },
      { title: t("Actions") },
    ],
    tableData: [],
    tableDataRes: {},
    CheckState: false,
    total: 0,
    tableLoading: true,                                   // 表格loading

    isShowCompareImage: false,                            // 对比图片弹窗状态
    imageModalLoading: true,                              // loading
    id: 0,                                                // 产品id
    title: '',                                            // 标题
    viewData: {},                                         // 对比图片数据
    progressCp: 0,                                        // 当前完成优化数量
    progressAll: 0,                                       // 需要完成总量
    isShowProgress: -1,                                   // 是否展示进度条
    optType: '',                                          // 优化类型
    loading: true,
    optPageType: 0,
    detailPre: false,
    detailNext: false,
    dPage: 1,
    dPageSize: 10,
    handleTypePro: -1,
    handleTypeCol: -1,
    handleTypeBlog: -1,
  };

  UNSAFE_componentWillMount() { }

  //进入页面调用接口
  componentDidMount() {
    let id = this.props.history.location?.state?.id;
    let title = this.props.history.location?.state?.title;
    if (id) {
      let autoState = store.getState().public.imageOptAuto;
      this.setState({
        id,
        title,
        isShowAutoState: autoState
      })
      this.getProductImagesData(id);
      this.getOptSchedule();
    }

    // 切换默认在顶部开始预览
    window.scrollTo(0, 0);
  }

  // 获取详情数据
  getProductImagesData = async (id) => {
    let { dPage, dPageSize } = this.state;
    let params = {
      prod_id: id,
      page: Number(dPage),
      pageSize: Number(dPageSize),
      handle_type: 2,
    }
    const res = await reqGetProductImagesData(params);
    if (res.ack === 1) {
      let listData = cloneDeep(res.data.data);
      listData.forEach(item => {
        item['restoreLoadingId'] = [];
        item['downloadLoadingId'] = [];
        if (Boolean(item.is_delete) || Boolean(item?.is_overdue)) {
          item['disabled'] = true;
        } else {
          item['disabled'] = false;
        }
      })
      this.setState({
        tableData: listData,
        tableDataRes: res.data,
        total: res.data.total,
        tableLoading: false,
        loading: false,
        detailPre: res.data.current_page === 1 ? false : true, // 是否存在上一页状态
        detailNext: res.data.current_page >= Math.ceil(res.data.total / res.data.per_page) ? false : true, // 是否存在下一页状态

      })
    } else {
      this.props.toggleToast(res.msg, true)
    }
  }

  // 获取额度及优化数据
  getOptSchedule = async (isGetData = false) => {
    let { id } = this.state;
    let params = {
      data_type: 1
    }
    const res = await reqGetOptSchedule(params);
    if (res) {
      if (isGetData) {
        this.getProductImagesData(id);
      }
      let optIn = Number(res.product?.opt_in || 0);
      let total = Number(res.product.opt_total);
      this.setState({
        progressCp: total - optIn,
        progressAll: total,
        optType: res.product?.process_type,
        optPageType: res.product.page_type,
        handleTypePro: Number(res.product.handle_type || -1),
        handleTypeCol: Number(res.collection.handle_type || -1),
        handleTypeBlog: Number(res.article.handle_type || -1),
      }, () => {
        let result = Number(res.product.process_result);
        if (total && result === 1) {
          // 判断是否该提示完成
          this.props.toggleToast(`${total} products ${res.product?.process_type === 'restore' ? 'restored' : 'optimized'}`, false);
          this.deleteTimeFunc();
          this.setState({
            progressCp: 0,
            progressAll: 0,
            isShowProgress: -1,
            optType: '',
          }, () => {
            setTimeout(() => {
              this.getProductImagesData(id);
            }, 3000)
          })
        } else if (total > 0) {
          this.setState({
            isShowProgress: 0,
            progressCp: total - optIn,
            progressAll: total,
          })
          // 判断是否该轮询
          if (timerArr.length === 0) {
            let timer = setInterval(() => {
              this.getOptSchedule(true);
            }, 5000);
            timerArr.push(timer)
          }
        } else {
          this.deleteTimeFunc();
        }
      })
    }
  }

  // 删除订阅器
  deleteTimeFunc = () => {
    timerArr.map(timer => {
      clearInterval(timer);
      timerArr.pop();
      return false;
    })
  }

  // 返回
  goBackImageOpt = () => {
    utils.routeJump(this, '/speedOpt/PageSpeed')
  }

  // 切换tab
  handleTypeTabsChange = (e) => { }

  // 搜索
  setQueryValue = (val) => {
    this.setState({
      queryValue: val
    })
  }

  // 获取table批量数据
  getTableItemState = (val) => {
    this.setState({
      tableItemState: val
    })
  }

  // 下载图片
  DownloadImage = (data) => {
    let { tableData } = this.state;
    let list = cloneDeep(tableData);
    let url = Boolean(data?.is_restore) ? data['before_file_path'] : data['after_file_path'];
    let filename = data['file_name'];
    list.forEach(item => {
      if (item['id'] === data['id'] && !Boolean(item['downloadLoadingId'].includes(data['id']))) {
        item['downloadLoadingId'].push(data['id']);
      }
    })
    this.setState({
      tableData: list
    }, async () => {
      // window.open(url);
      if (Boolean(url)) {
        if (url.startsWith('http:')) {
          const replaceUrl = url.replace('http:', 'https:');
          this.download(replaceUrl, filename)
        } else {
          this.download(url, filename)
        }
        this.requestDownload(data['opt_id'], data['id']);
      } else {
        this.props.toggleToast('Url is empty', true);
      }
      // let header = new Headers({
      //   Origin: window.location.origin,
      // })
      // fetch(url, {
      //   headers: header,
      //   mode: 'cors',
      // })
      //   .then(res => res.blob())
      //   .then((blob) => {
      //     const blobUrl = window.URL.createObjectURL(blob)
      //     this.download(blobUrl, filename)
      //     window.URL.revokeObjectURL(blobUrl);
      //     this.requestDownload(data['opt_data']['id']);
      //   })
    })

  }
  download(href, filename = '') {
    window.open(href);
    // const a = document.createElement('a')
    // a.download = filename
    // a.href = href
    // document.body.appendChild(a)
    // a.click()
    // a.remove()
  }

  // 发起下载成功请求
  requestDownload = async (id, oid) => {
    let params = {
      opt_id: id
    }
    const res = await reqUpdateIsDownload(params);
    if (res) {
      let { tableData } = this.state;
      let list = cloneDeep(tableData);
      list.forEach(item => {
        let indexId = item['downloadLoadingId'].indexOf(oid);
        if (item['id'] === oid && indexId > -1) {
          item['downloadLoadingId'].splice(indexId, 1);
        }
      })
      this.setState({
        tableData: list
      })
    }
  }

  // 单个恢复
  RestoreImageData = (data) => {
    let { id, tabKey, tableData } = this.state;
    let list = cloneDeep(tableData);
    list.forEach(item => {
      if (item['id'] === data['id'] && !Boolean(item['restoreLoadingId'].includes(data['id']))) {
        item['restoreLoadingId'].push(data['id']);
      }
    })
    this.setState({
      tableData: list
    }, async () => {
      let params = {
        data_type: tabKey + 1,
        data_list: [
          {
            data_id: id,
            img_ids: [data['img_id']],
            restore_type: ''
          }
        ],
        handle_type: 2,
      }
      const res = await reqBatchRestore(params);
      list.forEach(item => {
        let indexId = item['restoreLoadingId'].indexOf(data['id']);
        if (item['id'] === data['id'] && indexId > -1) {
          item['restoreLoadingId'].splice(indexId, 1);
        }
      })
      if (res.ack === 1) {
        // this.setState({
        //   tableData: list
        // }, () => {
        this.props.toggleToast(res.msg, false);
        setTimeout(() => {
          this.getOptSchedule(true);
        }, 3000)
        // })
      } else {
        this.setState({
          tableData: list
        }, () => {
          this.props.toggleToast(res.msg, true)
        })
      }
    })
  }

  // 批量-恢复
  optRestoreImage = () => {
    let { id, tableData, tableItemState } = this.state;
    this.setState({
      isShowProgress: 0,
      optType: 'restore',
      loading: true,
    }, async () => {
      let imgList = [];
      tableItemState[0].forEach(item => {
        tableData.forEach(data => {
          if (item === data['id'] && data['is_delete'] !== 1) {
            imgList.push(data['img_id'])
          }
        })
      })
      let params = {
        data_type: 1,
        data_list: [
          {
            data_id: id,
            img_ids: imgList,
            restore_type: tableItemState[1] ? 'all' : ''
          }
        ],
        handle_type: 2,
      }
      if (imgList.length === 0) {
        this.props.toggleToast("Please select items", false);
        this.setState({
          isShowProgress: -1,
          optType: '',
          loading: false,
        })
        return false;
      }
      const res = await reqBatchRestore(params);
      if (res.ack === 1) {
        this.props.toggleToast(res.msg, false);
        setTimeout(() => {
          this.getOptSchedule(true);
        }, 1500)
      } else {
        this.setState({
          loading: false,
          isShowProgress: -1,
          optType: '',
        })
        this.props.toggleToast(res.msg, true);
      }
    })
  }

  // 批量-优化
  ReOptimizeImage = () => {
    let { id, tableData, tableItemState } = this.state;
    this.setState({
      isShowProgress: 0,
      optType: 're-Optimize',
      loading: true,
    }, async () => {
      let imgList = [];
      tableItemState[0].forEach(item => {
        tableData.forEach(data => {
          if (item === data['id'] && data['is_delete'] !== 1) {
            imgList.push(data['img_id'])
          }
        })
      })
      let params = {
        data_type: 1,
        data_list: [
          {
            data_id: id,
            img_ids: imgList,
            restore_type: tableItemState[1] ? 'all' : ''
          }
        ],
        handle_type: 2,
      }
      if (imgList.length === 0) {
        this.props.toggleToast("Please select items", false);
        this.setState({
          isShowProgress: -1,
          optType: '',
          loading: false,
        })
        return false;
      }
      const res = await reqBatchReOptimize(params);
      if (res.ack === 1) {
        this.props.toggleToast(res.msg, false);
        setTimeout(() => {
          this.getOptSchedule(true);
        }, 1500)
      } else {
        this.setState({
          loading: false,
          isShowProgress: -1,
          optType: '',
        })
        this.props.toggleToast(res.msg, true);
      }
    })
  }

  // 打开对比图弹窗
  openDetailCompareModal = (data) => {
    this.setState({
      isShowCompareImage: true,
      imageModalLoading: true,
      viewData: data
    }, () => {
      setTimeout(() => {
        // 过渡图片加载时间，防止跳动过大
        this.setState({
          imageModalLoading: false,
        })
      }, 500)
    })
  }

  // 关闭对比弹窗
  closeImageCompare = () => {
    this.setState({
      isShowCompareImage: false,
      imageModalLoading: false,
    })
  }

  // 分页
  changeDetailTablePage = (e) => {
    this.setState({
      dPage: Number(e),
      tableLoading: true,
    }, () => {
      this.getProductImagesData(this.state.id);
    })
  }

  // 手动 页数
  changeDetailPageSizeData = (s) => {
    this.setState({
      dPage: 1,
      dPageSize: Number(s),
      tableLoading: true,
    }, () => {
      this.getProductImagesData(this.state.id);
    })
  }

  componentWillUnmount() {
    // 删除订阅器
    this.deleteTimeFunc();

    this.setState = () => false;
  }

  render() {
    const {
      title,
      tabKey,
      Headings,
      tableData,
      CheckState,
      total,
      tableLoading,
      isShowCompareImage,
      imageModalLoading,
      viewData,
      isShowProgress,
      progressCp,
      progressAll,
      optType,
      isShowAutoState,
      loading,
      optPageType,
      tableDataRes,
      detailPre,
      detailNext,
      dPage,
      handleTypePro,
      handleTypeCol,
      handleTypeBlog,
    } = this.state;

    const wwidth = window.innerWidth; // 屏幕宽度
    const startNum = ((tableDataRes.current_page - 1) * tableDataRes.per_page) + 1;
    const endNum = tableDataRes.current_page * tableDataRes.per_page <= tableDataRes.total ? tableDataRes.current_page * tableDataRes.per_page : tableDataRes.total;
    const footerContentText = wwidth > 550 ? <FooterPageSelect current_PageSize={tableDataRes.per_page} changePageSize={this.changeDetailPageSizeData} startNum={startNum} endNum={endNum} total={total} /> : t("Showing {{v1}} - {{v2}} of {{v3}} results", startNum, endNum, total);

    // 对比图片弹窗
    const compareImageModal = <ImageCompareModal
      type={'detail'}
      viewData={viewData}
      isShowCompareImage={isShowCompareImage}
      imageModalLoading={imageModalLoading}
      closeImageCompare={this.closeImageCompare}
    />

    // 底部
    const FooterHelpBox = <FooterTrustHelp />

    // 最终页面
    const PageContentInfo = <Page
      backAction={{ content: title, onAction: this.goBackImageOpt }}
      title={title}
    >
      <title>{`SEOAnt - ${title}`}</title>

      <div className={`Image_OptDetail_Info ${(isShowProgress === tabKey || isShowAutoState) ? 'isAutoDisabled' : ''}`}>
        <Card padding={0}>
          <BlockStack gap={200}>
            <div className='Every_Card_Space_All'>
              <Text variant="headingMd" as="h2">{t("Optimization detail")}</Text>
              <Text as="p" color="subdued">{t("Data of the picture will only be kept in the system for 30 days. Once the data past 30 days limit, you won't be able to optimize it anymore.")}</Text>
            </div>
            {/* <TableFilters
              itemStrings={['Product']}
              queryValue={queryValue}
              typeSelected={0}
              setSelectedTabsIndex={(e) => this.handleTypeTabsChange(e)}
              setQueryValue={(v) => this.setQueryValue(v)}
            /> */}
            <Tabs tabs={[{
              id: 'Product_detail',
              content: t("Product"),
              accessibilityLabel: 'Product',
              panelID: 'Product-content-1',
            },]} selected={tabKey} />
            {
              isShowAutoState ? <div className='flex_layout auto_opt_tip Every_Card_Space'>
                <Text variant="headingXs" as="h6">{t("Automatically optimizing")}</Text>
                <Spinner size='small' />
              </div> : (isShowProgress !== -1 && isShowProgress === tabKey) ? <div className='opt_progress_hitory Every_Card_Space'>
                <div className='flex_layout'>
                  <div className='flex_layout auto_opt_tip'>
                    <Text variant="headingXs" as="h6">
                      {
                        optType === 'restore' ? t("Restoring") : (optType === 're-Optimize' && optPageType === 0) ? t("Re-optimizing") : t("Manually optimization progress")
                      }
                    </Text>
                    <Spinner size='small' />
                  </div>
                  <span>{t("completed")}/{t("all")}:&nbsp;&nbsp;{progressCp}/{progressAll}</span>
                </div>
                {
                  progressAll > 0 && <ProgressBar tone='primary' progress={Number(((progressCp / progressAll) * 100).toFixed(0))} size='small' />
                }
              </div> : null
            }
            {
              tableLoading ? <div className='table_loading'><Spinner /></div> : <IndexTableImage
                id={`Detail_Table_${tabKey}`}
                tabKey={tabKey}
                loading={loading}
                headings={Headings}
                dataList={tableData}
                checkState={CheckState}
                total={total}
                isShowProgress={isShowProgress}
                isShowAutoState={isShowAutoState}
                obj_name={'products'}
                getTableItemState={this.getTableItemState}
                promotedBulkActions={(isShowProgress === tabKey || isShowAutoState) ? [
                  {
                    content: <Tooltip content={
                      isShowAutoState ? t("This feature is only available when the 'Optimize Images Automatically' function is disabled.") :
                        (tabKey === 0 && handleTypePro === 1) ?
                          t("Please wait: Alt optimization in progress (Operation available after completion)") :
                          t("Please wait: Image optimization in progress (Operation available after completion)")
                    }>
                      <span>{t("Restore")}</span>
                    </Tooltip>,
                    disabled: true
                  },
                  {
                    content: <Tooltip content={
                      isShowAutoState ? t("This feature is only available when the 'Optimize Images Automatically' function is disabled.") :
                        (tabKey === 0 && handleTypePro === 1) ?
                          t("Please wait: Alt optimization in progress (Operation available after completion)") :
                          t("Please wait: Image optimization in progress (Operation available after completion)")
                    }>
                      <span>{t("Re-optimize")}</span>
                    </Tooltip >,
                    disabled: true
                  },
                ] : [
                  {
                    content: t("Restore"),
                    onAction: this.optRestoreImage
                  },
                  {
                    content: t("Re-optimize"),
                    onAction: this.ReOptimizeImage
                  },
                ]}
                tableType={'detail'}
                openDetailCompareModal={this.openDetailCompareModal}
                RestoreImageData={this.RestoreImageData}
                DownloadImage={this.DownloadImage}
                handleTypePro={handleTypePro}
                handleTypeCol={handleTypeCol}
                handleTypeBlog={handleTypeBlog}
              />
            }
            {/* 分页 */}
            {
              tableLoading ? null :
                (tableData.length > 0 && <div className='justify_center sticky_footer'>
                  <Pagination
                    label={footerContentText}
                    hasPrevious={detailPre}
                    onPrevious={() => this.changeDetailTablePage(dPage - 1)}
                    hasNext={detailNext}
                    onNext={() => this.changeDetailTablePage(dPage + 1)}
                  />
                </div>)
            }
          </BlockStack>
        </Card>
      </div>
      {FooterHelpBox}
    </Page>

    return (
      <div id="ImageOptimizationDetail">
        {PageContentInfo}
        {compareImageModal}
      </div>
    );
  }
}

export default withRouter(ImageOptDetail);
